import { gql } from "@apollo/client";
import { useLazyQuery } from "../../Hooks/graphql_utils";
import { BuilderEmailDialog } from "./BuilderEmail";
import { Button } from "../../Elements";
import React, { useEffect, useMemo, useState } from "react";
import { Intent, Position, Tooltip } from "@blueprintjs/core";

const GET_TEMPLATE_NAMES_QUERY = gql`
    query getJobDetailPageTemplates {
        getJobDetailPageTemplates {
            id
            display_name
            aws_name
            is_prep
            is_app
            is_detail
            is_pebble
            is_gunite
            is_warranty
        }
    }
`

export default ({
    parentTemplateData,
    disabled,
    formModified,
    jobId,
    jobDetailId,
    contactEmail,
    supervisorEmail,
    large = false,
    jobDetailType,
    pebblePhaseTypes = [],
    buttonStyle,
    isScheduleBoard=false
}) => {
    const [dialogOpen, setDialogOpen] = useState(false)
    const [data, setData] = useState()
    const [loadTemplateNamesQuery, { loading, error }] = useLazyQuery(GET_TEMPLATE_NAMES_QUERY, {
        fetchPolicy: 'network-only',
        onCompleted: data => {
            setData(data.getJobDetailPageTemplates)
        }
    })

    useEffect(() => {
        if (parentTemplateData) {
            setData(parentTemplateData)
        } else {
            loadTemplateNamesQuery()
        }
    }, [parentTemplateData, loadTemplateNamesQuery])

    const filteredData = useMemo(() => {
        return data?.filter(template => {
            const { is_prep, is_app, is_detail, is_pebble, is_gunite, is_warranty } = template
            switch (jobDetailType) {
                case 1:
                    return is_gunite
                case 2:
                    if (pebblePhaseTypes.length > 0) {
                        if (pebblePhaseTypes.includes(1) && is_prep) return is_prep
                        else if (pebblePhaseTypes.includes(2) && is_app) return is_app
                        else if (pebblePhaseTypes.includes(3) && is_detail) return is_detail
                        else return false
                    }else{
                        return is_pebble
                    }      
                case 3:
                    return is_warranty
                default:
                    return false
            }
        })
    }, [data, jobDetailType, pebblePhaseTypes])

    const missingRequiredJobInfo = !jobDetailId
    const missingBothEmails = !contactEmail && !supervisorEmail
    const buttonDisabled = disabled || formModified || !!error || missingRequiredJobInfo || missingBothEmails || !filteredData

    return (
        <>
            <Tooltip
                content={formModified
                    ? 'You have unsaved form progress. Please save or reload the page to send a builder email.'
                    : missingBothEmails ?
                        'Cannot send email since neither company contact email nor supervisor email found.'
                        : error
                            ? 'An error occurred that prevented from receiving email templates. Please reload your page.'
                            : 'Loading job details...'}
                position={Position.BOTTOM}
                disabled={!buttonDisabled}
            >
                <Button
                    loading={loading}
                    icon={error ? "error" : "envelope"}
                    minimal = {isScheduleBoard ? true : false}
                    large={isScheduleBoard ? false : large}
                    disabled={buttonDisabled}
                    intent={error ? Intent.DANGER : Intent.PRIMARY}
                    onClick={() => setDialogOpen(!dialogOpen)}
                    style={buttonStyle}
                />
            </Tooltip>
            {!buttonDisabled &&
                <BuilderEmailDialog
                    data={filteredData}
                    open={dialogOpen}
                    setOpen={setDialogOpen}
                    jobId={jobId}
                    jobDetailId={jobDetailId}
                    hasContactEmail={!!contactEmail}
                    hasSupervisorEmail={!!supervisorEmail}
                />}
        </>
    )
}
